import { mainClient } from '~/network';
import utils from '../../../utils';

const state = {
    idxAttemptsLimit: 3,

    getIdxStateResult: null,
    getIdxStateIsLoading: false,
    getIdxStateError: null,

    submitIdxResult: null,
    submitIdxIsLoading: false,
    submitIdxError: null,
};

const getters = {
    isIdxLimitExceeded(state) {
        return state.getIdxStateResult?.limitExceeded || state.getIdxStateResult?.attemptNo >= state.idxAttemptsLimit;
    },
};

const actions = {
    async getIdxState({ state }) {
        if (state.getIdxStateIsLoading) {
            return;
        }

        state.getIdxStateIsLoading = true;

        const { data, error } = await mainClient.users.requests.getIdxVerificationState();
        if (error) {
            state.getIdxStateError = utils.network.parseError(error, true);
            state.getIdxStateResult = null;
        } else {
            state.getIdxStateError = null;
            state.getIdxStateResult = data;
        }
        state.getIdxStateIsLoading = false;
    },
    async submitIdxVerification({ state }, { onSuccess = null, ...payload }) {
        if (state.submitIdxIsLoading) {
            return;
        }
        state.submitIdxIsLoading = true;

        const { data, error } = await mainClient.users.requests.submitIdxVerification(payload);
        if (error) {
            state.submitIdxError = utils.network.parseError(error, true);
            state.submitIdxResult = null;
        } else {
            state.submitIdxError = null;
            state.submitIdxResult = data;
            if (typeof onSuccess === 'function') {
                onSuccess(data);
            }
        }
        state.submitIdxIsLoading = false;
    },
};

const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
